// events.js contains constants for event names to be used for instrumentation
// They are structured in a objectName_actionName syntax
// the 'app' at the front provides the enterprise context for the event
// where app means the Checkbox platform

const APP = {
  BLOCK_ADDED: 'app:studioBlock_added',
};

// See product analytics tracking plan:
// https://www.notion.so/9f6d04d8532843ff85ef21f31c25a892?v=b3aef1e62de141ceb44b66905201cb4c&pvs=4
const ASSISTANT = {
  CHAT_MESSAGE_RATED: 'ai_chat_message_rated',
  CHAT_MESSAGE_SENT: 'ai_chat_message_sent',
};

const FEATURE = {
  IS_SENSITIVE: {
    CLICKED: 'app:isSensitive_clicked',
  },
};

const DATABASE = {
  CREATED: 'app:database_created',
  DELETED: 'app:database_deleted',
  IMPORTED: 'app:database_imported',
  EXPORTED: 'app:database_exported',
};

const INTEGRATIONS = {
  CLICKED: 'app:integrations_clicked',
  UPDATED: 'app:integrations_updated',
};

const PORTAL = {
  VIEWED: 'app:portal_viewed',
};

const DASHBOARD = {
  CREATED: 'app:dashboard_created',
  VIEWED: 'app:dashboard_viewed',
  UPDATED: 'app:dashboard_updated',
};

const WIDGET = {
  CREATED: 'app:widget_created',
  REFRESHED_ASSESSEMNT: 'app:widget_refresh_assessment_clicked',
};

const WORKFLOW = {
  COMMENT_ADDED: 'app:workflow_comment_added',
  BLOCK_EXECUTED: 'app:workflow_block_executed',
};

const TICKETING_EMAIL = {
  MESSAGE_MOVED: 'app:ticketing_email_message_moved',
  MESSAGE_CREATE_NEW_TICKET: 'app:ticketing_email_message_create_new_ticket',
  BOARD_VIEW_DOWNLOAD_CSV: 'app:ticketing_board_view_download_csv',
  BOARD_VIEW_REORDER: 'app:ticketing_board_view_reorder',
  REPORTING_WIDGET_DOWNLOAD_CSV: 'app:reporting_widget_download_csv',
};

const ADOBE_SIGN_BLOCK = {
  ADD_RECIPIENT: 'app:adobesign_add_recipient_clicked',
  CUSTOMIZE_RECIPIENT_EMAIL: 'app:adobesign_customize_recipient_emails_clicked',
  SELECT_CONFIG_MODE: 'app:adobesign_config_mode_selected',
  TOGGLE_SIGNING_ORDER: 'app:adobesign_signing_order_toggled',
};

const DOCUSIGN_BLOCK = {
  ADD_RECIPIENT: 'app:docusign_add_recipient_clicked',
  CUSTOMIZE_RECIPIENT_EMAIL: 'app:docusign_customize_recipient_emails_clicked',
  SELECT_CONFIG_MODE: 'app:docusign_config_mode_selected',
  TOGGLE_INCLUDE_COC: 'app:docusign_include_coc_toggled', // unique to docusign
  TOGGLE_SIGNING_ORDER: 'app:docusign_signing_order_toggled',
};

const EMBEDDED_ESIGNATURE_RUNTIME = {
  ADOBESIGN: {
    COMPLETED: 'app:adobesign_embedded_view_completed',
    EXPIRED: 'app:adobesign_embedded_view_expired',
    LOAD_FAILED: 'app:adobesign_embedded_view_load_failed',
    LOAD_SUCCESSFUL: 'app:adobesign_embedded_view_loaded',
  },
  DOCUSIGN_V2: {
    COMPLETED: 'app:docusign_embedded_view_completed',
    EXPIRED: 'app:docusign_embedded_view_expired',
    LOAD_FAILED: 'app:docusign_embedded_view_load_failed',
    LOAD_SUCCESSFUL: 'app:docusign_embedded_view_loaded',
  },
};

export default {
  ADOBE_SIGN_BLOCK,
  APP,
  ASSISTANT,
  DASHBOARD,
  DATABASE,
  DOCUSIGN_BLOCK,
  EMBEDDED_ESIGNATURE_RUNTIME,
  FEATURE,
  INTEGRATIONS,
  PORTAL,
  TICKETING_EMAIL,
  WIDGET,
  WORKFLOW,
};
